<template>
  <div
    :disabled="isDisabled"
    @click="openWorkflowInNewTab"
    class="item item-with-icon"
    :class="{ 'disabled': isDisabled }"
  >
    <base-icon icon-name="external-link" iconColor="#8c8c8c" />
    <span class="no-child">Open in new Tab</span>
  </div>
</template>

<script>
import OptionModal from "./option-modal";

export default {
  name: "MoreOptionsNewTab",
  components: { OptionModal },
  props: {
		currentWorkflowUrl: { type: String }
  },
  data() {
    return {
      isDisabled: false,
    }
  },
  methods: {
		openWorkflowInNewTab() {
      window.open(this.currentWorkflowUrl);
		}
  }
}
</script>

<style lang="scss" scoped>
.item {
  font-weight: 400;
	font-style: normal;
	font-size: 16px;
	white-space: pre-line;

  &.item-with-icon .icons {
  	margin-right: 23px;
  }
}
</style>
